module.exports = __webpack_public_path__ + "img/yqtx-gongyi.bdd9ae11.png";